import { RequestOptions } from './../modal/RequestOptions';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environments';
import { Observable } from 'rxjs';
import { relatorio } from '../modal/relatorio';

@Injectable({
  providedIn: 'root'
})
export class RelatorioService {

  constructor(private http: HttpClient) { }

  private apiUrl = environment.API_URL;
  private map = this.apiUrl+"ss.relatorios";

  getPaginacao(pageNumber: number, pageSize: number, filtroDesc: string, filtroCodigo: number | undefined, filtroEtapa: string): Observable<any> {
    //return this.http.get(this.apiUrl+this.map+'/find', {withCredentials: true});
    var variaveis = "";
    if (filtroCodigo != undefined)
      variaveis = '&filtroCod=' + filtroCodigo;
    else
      variaveis = '&filtroCod=';

    return this.http.get(this.map + '/findpaginacao?pageNumber=' + pageNumber + '&pageSize=' + pageSize + '&FiltroNome=' + filtroDesc + '&filtroEtapa=' + filtroEtapa+ variaveis, { withCredentials: true });

  }

  findRelatorio(id: number, filtro: any): Observable<any> {
    return this.http.post<any>(`${this.map}/findRelatorios/codigo=${id}`, filtro );
  }

  findById(codigo: number): Observable<any> {
    return this.http.get<any>(`${this.map}/findbyId/${codigo}`);
  }

  findByCodigoAndEtapa(codigo: number, etapa: number): Observable<any> {
    return this.http.get<any>(`${this.map}/findByCodigoAndEtapa?codigo=`+codigo+"&etapa="+etapa);
  }
  getFindAllEtapas1(): Observable<any> {
    return this.http.get(this.map + '/findALLEtapas1', { withCredentials: true });
  }

  getRelatorioPontoAtendimento(postos: number[] | undefined, filtroPostoNome: string, codigo: number): Observable<any> {
    var url = this.map+'/getRelatorioPontoAtendimento?filtroPostoNome='+filtroPostoNome+"&codigo="+codigo;
    return this.http.post(url, {params: postos}, {withCredentials: true});
  }

  getRelatorioHorasProdutivas(postos: number[] | undefined, filtroPostoNome: string, codigo: number): Observable<any> {
    var url = this.map+'/getRelatorioHorasProdutivas?filtroPostoNome='+filtroPostoNome+"&codigo="+codigo;
    return this.http.post(url, {params: postos}, {withCredentials: true});
  }

  getRelatorioGraficoJustificativa(postos: number[] | undefined, filtroPostoNome: string, codigo: number, DataInit: number | null): Observable<any> {
    var url = this.map+'/getRelatorioGraficoJustificativa?filtroPostoNome='+filtroPostoNome+"&codigo="+codigo;
    if(DataInit != null)
    url = url + "&DataInit="+DataInit;
    return this.http.post(url, {params: postos}, {withCredentials: true});
  }

  getRelatorioVagasDesproporcionais(postos: number[] | undefined, filtroPostoNome: string, codigo: number): Observable<any> {
    var url = this.map+'/getRelatorioVagasDesproporcionais?filtroPostoNome='+filtroPostoNome+"&codigo="+codigo;
    return this.http.post(url, {params: postos}, {withCredentials: true});
  }

  getRelatorioAtendentes(postos: number[] | undefined, filtroPostoNome: string, codigo: number): Observable<any> {
    var url = this.map+'/getRelatorioAtendentes?filtroPostoNome='+filtroPostoNome+"&codigo="+codigo;
    return this.http.post(url, {params: postos}, {withCredentials: true});
  }

  deleteItem(id: string): Observable<any> {
    let login = localStorage.getItem('login');
    return this.http.delete<any>(`${this.map}/deletar?nomeUsuario=`+login+`&id=${id}`);
  }

  adicionarItem(item: relatorio): Observable<relatorio> {
    let login = localStorage.getItem('login');
    return this.http.post<relatorio>(this.map+'/cadastro?nomeUsuario='+login, item, {withCredentials: true});
  }

  editarItem(id: string): Observable<any> {
    return this.http.get<any>(`${this.map}/findbyId/${id}`);
  }
}
